import { APIService } from "./index";

export const codeGeneratorService =async (project_id, projectName, databaseScript) => {
    return await APIService.api().post(`/ProjectSetup/setup/`,
        {
            projectName: projectName,
            databaseScript: databaseScript,
            neoAssistProjectId: project_id
        }
    )
}

export const getProjectLinksService = async (projectId) => {
    try {
        console.log("we are in the")
        const response = await APIService.api().get(`/ProjectSetup/links/${projectId}`);
        return response;
    } catch (error) {
        if (error.response?.status === 401) {
            throw new Error('Unauthorized access');
        } else if (error.response?.status === 404) {
            throw new Error('Project links not found');
        }
        throw error;
    }
}

export const getProjectDownloadUrlsService = async (projectId) => {
    try {
        const response = await APIService.api().get(`/ProjectSetup/download/${projectId}`);
        return response;
    } catch (error) {
        if (error.response?.status === 401) {
            throw new Error('Unauthorized access');
        } else if (error.response?.status === 404) {
            throw new Error('Download URLs not found');
        }
        throw error;
    }
}